import classcat from "classcat"
import React from "react"

import commonStyles from "../ProjectBudgetForm.module.css"
import styles from "./TotalsRow.module.css"

import { formatCurrency } from "~/helpers/CurrencyHelper"
import DurationHelper from "~/helpers/DurationHelper"
import { formatMinutesToDays } from "~/helpers/budgetHelper"

import { useProjectBudgetFormContext } from "../ProjectBudgetFormProvider"
import Column from "../TableColumn"
import TableInfo from "../TableInfo"

type Props = {
  totalMinutes: number
  totalAllocated: number
  defaultFullTimeMinutes: number
}

const TotalsRow: React.FC<Props> = (props) => {
  const { totalMinutes, totalAllocated, defaultFullTimeMinutes } = props

  const { showNonBillableView, showDayView } = useProjectBudgetFormContext()

  return (
    <TableInfo
      sticky
      className={classcat([
        styles.totalsWrapper,
        commonStyles.totalsWrapper,
        {
          [styles.nbView]: showNonBillableView,
        },
      ])}
      offset={0}
      dataTest="phase-and-role-total"
    >
      <Column textAlign="left">
        <span>Revenue Budget</span>
      </Column>
      <Column dataTest="time-total" textAlign="right">
        {showDayView
          ? formatMinutesToDays(totalMinutes, defaultFullTimeMinutes)
          : DurationHelper.formatMinutesToTime(totalMinutes)}
      </Column>
      {!showNonBillableView && (
        <Column dataTest="budget-total" textAlign="right">
          {formatCurrency(totalAllocated)}
        </Column>
      )}
    </TableInfo>
  )
}

export default TotalsRow
